var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.994 1.782c-1.159-0.043-1.919 1.208-1.709 2.262v5.523h1.465c0.01151-2.061-0.02306-4.122 0.01734-6.182 0.573-0.3028 1.275-0.07992 1.909-0.1431h5.884v-1.46h-7.567zm12.45 0v1.46c2.556 0.01155 5.112-0.02308 7.667 0.01728 0.3038 0.5711 0.08019 1.271 0.1436 1.903v4.405h1.465c-0.02215-2.148 0.04514-4.301-0.03523-6.446-0.2062-1.054-1.392-1.498-2.359-1.34-2.294 0-4.587 0-6.881-5e-7zm-14.16 12.65c0.02212 2.148-0.04514 4.301 0.03526 6.446 0.2061 1.054 1.392 1.498 2.359 1.34h6.881v-1.46c-2.556-0.01155-5.112 0.02307-7.667-0.01728-0.3038-0.5711-0.08019-1.271-0.1436-1.903v-4.405h-1.465zm21.97 0c-0.01152 2.061 0.02305 4.122-0.01734 6.182-0.573 0.3028-1.275 0.07992-1.909 0.1431h-5.884v1.46c2.643-0.02249 5.291 0.04554 7.931-0.0351 1.057-0.2055 1.503-1.388 1.344-2.351v-5.399c-0.4882-3e-5 -0.9764 5.8e-5 -1.465-4.4e-5z",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.978 6.501c4.047 0.00328 8.095-0.00655 12.14 0.00491 0.6124 0.04061 0.9502 0.6705 0.8647 1.226-0.0033 2.966 0.0066 5.931-0.0049 8.897-0.04097 0.6071-0.6763 0.942-1.237 0.8573-3.955-0.0032-7.91 0.0066-11.86-0.0049-0.6125-0.04065-0.9502-0.6705-0.8648-1.226 0.0033-2.966-0.00661-5.931 0.00496-8.897 0.03901-0.4758 0.477-0.8674 0.9585-0.8573z",
    fill: "none",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.11a4485ac4048afcdf62ed27999e3cca.svg";
export { ForwardRef as ReactComponent };